import React, {Component} from 'react';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Link, NavLink, Redirect} from 'react-router-dom';
import {I18n, setLocale} from "react-redux-i18n";
import {Messages} from 'primereact/messages';
import {connect} from "react-redux";

import {
    getFormattedPhone,
    getFormErrorMessage, getPhoneLang,
    isFormFieldInvalid, localeEnUSOptions,
    localeFrFROptions,
    manageApiErrors,
    phone
} from "../helpers/utils";
import {Formik} from 'formik';
import PhoneInput from "react-phone-input-2";
import * as Yup from "yup";
import {Password} from "primereact/password";
import {Checkbox} from "primereact/checkbox";
import {Dropdown} from 'primereact/dropdown';
import {classNames} from "primereact/utils";
import UserService from "../services/UserService";
import {setMessage} from "../actions/message";
import {Calendar} from "primereact/calendar";
import moment from "moment";
import {addLocale} from 'primereact/api';
import {Steps} from "primereact/steps";

class Register extends Component {

    emptyElement = {
        firstName: '',
        lastName: '',
        referralCode: '',
        birthday: '',
        locale: '',
        genderTypeEnum: '',
        email: '',
        password: '',
        password2: '',
        type: '',
        mobilePhone: phone,
        whatsappNumber: phone,
        cgu: false
    };

    constructor(props) {
        super(props);
        this.saveElement = this.saveElement.bind(this);
        this.monthNavigatorTemplate = this.monthNavigatorTemplate.bind(this);
        this.yearNavigatorTemplate = this.yearNavigatorTemplate.bind(this);
        this.loadItems = this.loadItems.bind(this);
        this.elementService = new UserService();

        this.state = {
            loadingLang: false,
            currentStep: 1,
            stepItems: null,
            loading: false,
            recaptcha: false,
            recaptchaResponse: null,
        };

        this.formikProps = {
            initialValues: this.emptyElement,
            validationSchema: {
                1: Yup.object().shape({
                    lastName: Yup.string().required(I18n.t('FIELD_IS_REQUIRED')),
                    genderTypeEnum: Yup.string().required(I18n.t('FIELD_IS_REQUIRED')),
                    birthday: Yup.string().required(I18n.t('FIELD_IS_REQUIRED')),
                    type: Yup.string().required(I18n.t('FIELD_IS_REQUIRED')),
                }),
                2: Yup.object().shape({
                    email: Yup.string().required(I18n.t('FIELD_IS_REQUIRED')).email(I18n.t('INVALID_EMAIL')),
                    password: Yup
                        .string()
                        .required(I18n.t('FIELD_IS_REQUIRED'))
                        .min(6, I18n.t('PASSWORD_SHORT')),
                    password2: Yup
                        .string()
                        .required(I18n.t('FIELD_IS_REQUIRED'))
                        .oneOf([Yup.ref('password'), null], I18n.t('PASSWORD_MUST_MATCH')),
                    cgu: Yup.bool().oneOf([true], I18n.t('ACCEPT_CGU_TO_CONTINUE')),
                    mobilePhone: Yup.object().shape({
                        formattedNumber: Yup.string().required(I18n.t('FIELD_IS_REQUIRED'))
                    }),
                })
            }
        };
        addLocale('fr', localeFrFROptions);
        addLocale('en', localeEnUSOptions);
    }

    async handleNext(props) {
        await props.validateForm();
        props.setTouched({
            firstName: true,
            lastName: true,
            genderTypeEnum: true,
            birthday: true,
            type: true,
        });
        if (!props.isValid) {
            return;
        }
        this.setState({currentStep: 2});
    };

    handlePrev = () => {
        this.setState({currentStep: 1});
    };

    componentDidMount() {
        this.loadGenresEnums();
        this.loadTypes();
        this.loadItems();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.locale !== this.props.locale) {
            this.loadGenresEnums();
            this.loadTypes();
            this.loadItems();
        }
    }

    loadGenresEnums() {
        this.genresEnums = [
            {name: I18n.t('MALE'), code: 'MALE'},
            {name: I18n.t('FEMALE'), code: 'FEMALE'}
        ];
    }

    loadItems() {
        let items = [
            {label: I18n.t('YOUR_PROFILE')},
            {label: I18n.t('YOUR_ACCOUNT')}
        ];
        this.setState({stepItems: items});
    }

    loadTypes() {
        this.types = [
            {name: I18n.t('MERCHANT_DESCRIPTION'), code: 'MERCHANT'},
            {name: I18n.t('DEVELOPER_DESCRIPTION'), code: 'DEVELOPER'},
            {name: I18n.t('MERCHANT_DEVELOPER_DESCRIPTION'), code: 'MERCHANT_DEVELOPER'}
        ];
    }

    monthNavigatorTemplate(e) {
        return <Dropdown value={e.value} options={e.options}
                         onChange={(event) => e.onChange(event.originalEvent, event.value)} style={{lineHeight: 1}}/>;
    }

    yearNavigatorTemplate(e) {
        return <Dropdown value={e.value} options={e.options}
                         onChange={(event) => e.onChange(event.originalEvent, event.value)} className="p-ml-2"
                         style={{lineHeight: 1}}/>;
    }

    handleLanguageLinkClick = (e, code) => {
        this.setState({
            loadingLang: true
        });
        console.log("handling click")
        e.preventDefault();
        this.props.dispatch(setLocale(code))
        this.setState({
            loadingLang: false
        });
    };

    saveElement = (element, {setStatus, setErrors}) => {
        element.locale = this.props.locale
        element.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        this.setState({loading: true});
        this.elementService.add(element)
            .then((response) => {
                this.setState({
                    element: this.emptyElement,
                    isRegistered: true
                });
                this.formikProps.initialValues = this.emptyElement;
                this.props.dispatch(setMessage("ACCOUNT_CREATED_SUCCESSFULLY"))
                this.props.history.push("/login");
            })
            .catch(error => {
                this.setState({
                    loading: false,
                });
                let errors = error.response.data.errors;
                if (errors && errors['birthday'] != null) {
                    this.setState({currentStep: 1});
                }
                setErrors(manageApiErrors(errors, ['whatsappNumber', 'mobilePhone']));
            });
    }

    render() {
        const {isLoggedIn} = this.props;
        if (isLoggedIn) {
            return <Redirect to="/"/>;
        }

        let localeButton;
        if (this.props.locale === 'fr-FR') {
            if (!this.state.loadingLang) {
                localeButton = <button type="button" className="layout-topbar-action p-link"
                                       onClick={e => this.handleLanguageLinkClick(e, "en-US")}>
                    <img src="assets/demo/flags/flag_placeholder.png" alt='English'
                         className="primeface-flag primeface-flag-uk" width={30} height={20}/>
                    <span style={{marginLeft: '.5em', verticalAlign: 'middle'}}
                          className="image-text white-color">English</span>
                </button>
            } else {
                localeButton = <Button label="Loading" iconPos="right" loading/>
            }
        } else {
            if (!this.state.loadingLang) {
                localeButton = <button type="button" className="layout-topbar-action p-link"
                                       onClick={e => this.handleLanguageLinkClick(e, "fr-FR")}>
                    <img src="assets/demo/flags/flag_placeholder.png" alt='Français'
                         className="primeface-flag primeface-flag-fr" width={30} height={20}/>
                    <span style={{marginLeft: '.5em', verticalAlign: 'middle'}}
                          className="image-text white-color">Français</span>
                </button>
            } else {
                localeButton = <Button label="Chargement en cours" iconPos="right" loading/>
            }
        }

        return (
            <div className="pages-body login-page p-d-flex p-flex-column">
                <div className="topbar p-p-3 p-d-flex p-jc-between p-flex-row p-ai-center">
                    <div className="topbar-left p-ml-3 p-d-flex">
                        <div className="logo">
                            <img src="assets/layout/images/logo2x.png" alt=""/>
                        </div>
                    </div>
                    <div className="topbar-right p-mr-3 p-d-flex">
                        {localeButton}
                    </div>
                </div>

                <div className="p-as-center p-mt-auto p-mb-auto" style={{width: '400px'}}>
                    <div className="pages-panel card p-d-flex p-flex-column">
                        <div className="pages-header p-px-3 p-py-1 p-mb-6">
                            <h2>{I18n.t('CREATE_AN_ACCOUNT')}</h2>
                        </div>

                        <div className="input-panel p-d-flex p-flex-column p-px-3">
                            <Messages ref={(el) => this.msgs = el}/>

                            {this.state.stepItems != null &&
                                <Steps model={this.state.stepItems} activeIndex={this.state.currentStep - 1}/>}

                            <Formik
                                enableReinitialize
                                initialValues={this.formikProps.initialValues}
                                validationSchema={this.formikProps.validationSchema[this.state.currentStep]}
                                onSubmit={this.saveElement}
                            >
                                {props => {
                                    console.log(props)
                                    return <form onKeyDown={(event) => event.keyCode === 13 && event.preventDefault()}
                                                 onSubmit={props.handleSubmit} className="col-10">

                                        {this.state.currentStep === 1 && (
                                            <>
                                                <div className="p-inputgroup">
                                            <span className="p-float-label">
                                                <InputText
                                                    type="text"
                                                    name="firstName"
                                                    value={props.values.firstName}
                                                    onChange={props.handleChange}
                                                    id="firstName"/>
                                                <label htmlFor="firstName">{I18n.t('FIRST_NAME')}</label>
                                            </span>
                                                </div>

                                                <div className="p-inputgroup p-mt-3">
                                            <span className="p-float-label">
                                                <InputText
                                                    type="text"
                                                    name="lastName"
                                                    value={props.values.lastName}
                                                    onChange={props.handleChange}
                                                    id="lastName"
                                                    className={classNames({'p-invalid': isFormFieldInvalid(props, 'lastName')})}
                                                />
                                                <label htmlFor="lastName">{I18n.t('LAST_NAME')}</label>
                                            </span>
                                                </div>
                                                <div className="p-inputgroup">
                                                    {getFormErrorMessage(props, 'lastName')}
                                                </div>

                                                <div className="p-fluid p-grid p-formgrid p-mt-3">
                                                    <div className="p-field p-col-12">
                                                        <Dropdown
                                                            placeholder={I18n.t('CHOOSE_YOUR_SEX')}
                                                            name="genderTypeEnum"
                                                            id="genderTypeEnum"
                                                            value={props.values.genderTypeEnum}
                                                            onChange={props.handleChange}
                                                            options={this.genresEnums}
                                                            optionLabel="name"
                                                            optionValue="code"
                                                            className={classNames({'p-invalid': isFormFieldInvalid(props, 'genderTypeEnum')})}
                                                        />
                                                        {getFormErrorMessage(props, 'genderTypeEnum')}
                                                    </div>
                                                </div>

                                                <div className="p-fluid p-grid p-formgrid">
                                                    <div className="p-field p-col-12">
                                                        <Calendar
                                                            id="birthday"
                                                            value={props.values.birthday && new Date(props.values.birthday)}
                                                            onChange={(event) => props.setFieldValue('birthday', moment(event.value).format('YYYY-MM-DD'))}
                                                            className={classNames({'p-invalid': isFormFieldInvalid(props, 'birthday')})}
                                                            monthNavigator yearNavigator yearRange="1900:2030"
                                                            monthNavigatorTemplate={this.monthNavigatorTemplate}
                                                            yearNavigatorTemplate={this.yearNavigatorTemplate}
                                                            dateFormat="dd/mm/yy"
                                                            placeholder={I18n.t('BIRTHDAY_DATE')}
                                                            locale={this.props.locale?.split('-')[0]}
                                                            showIcon/>
                                                        {getFormErrorMessage(props, 'birthday')}
                                                    </div>
                                                </div>

                                                <div className="p-fluid p-grid p-formgrid">
                                                    <div className="p-field p-col-12">
                                                        <Dropdown
                                                            placeholder={I18n.t('CHOOSE_YOUR_ACCOUNT_TYPE')}
                                                            name="type"
                                                            id="type"
                                                            value={props.values.type}
                                                            onChange={props.handleChange}
                                                            options={this.types}
                                                            optionLabel="name"
                                                            optionValue="code"
                                                            className={classNames({'p-invalid': isFormFieldInvalid(props, 'type')})}
                                                        />
                                                        {getFormErrorMessage(props, 'type')}
                                                    </div>
                                                </div>

                                                <Button type="button" onClick={() => this.handleNext(props)}
                                                        disabled={!props.dirty}
                                                        style={{width: '100%'}}
                                                        className="login-button p-px-3"
                                                        label={I18n.t('NEXT')}>
                                                </Button>
                                            </>
                                        )}

                                        {this.state.currentStep === 2 && (
                                            <>
                                                <div className="p-inputgroup ">
                                                    <span className="p-float-label">
                                                        <InputText
                                                            type="email"
                                                            name="email"
                                                            value={props.values.email}
                                                            onChange={props.handleChange}
                                                            id="email"
                                                            className={classNames({'p-invalid': isFormFieldInvalid(props, 'email')})}
                                                        />
                                                        <label htmlFor="email">{I18n.t('EMAIL')}</label>
                                                    </span>
                                                </div>
                                                <div className="p-inputgroup">
                                                    {getFormErrorMessage(props, 'email')}
                                                </div>

                                                <div className="p-inputgroup p-mt-3">
                                                    <span className="p-float-label">
                                                        <PhoneInput
                                                            key={this.props.locale}
                                                            enableSearch={true}
                                                            searchPlaceholder={I18n.t('SEARCH_COUNTRY')}
                                                            searchNotFound={I18n.t('NO_COUNTRY_FOUND')}
                                                            specialLabel={I18n.t('PHONE_NUMBER') + '*'}
                                                            placeholder={I18n.t('PHONE_NUMBER')}
                                                            isValid={props.values.mobilePhone.valid}
                                                            localization={getPhoneLang(this.props.locale)}
                                                            inputStyle={{width: '100%'}}
                                                            country={'cm'}
                                                            name="mobilePhone"
                                                            value={props.values.mobilePhone.formattedNumber}
                                                            onChange={(value, country) => props.setFieldValue('mobilePhone', getFormattedPhone(value, country))}
                                                        />
                                                    </span>
                                                </div>
                                                <div className="p-inputgroup">
                                                    {getFormErrorMessage(props, 'mobilePhone', 'formattedNumber')}
                                                </div>

                                                <div className="p-inputgroup p-mt-3">
                                                    <span className="p-float-label">
                                                        <PhoneInput
                                                            key={this.props.locale}
                                                            enableSearch={true}
                                                            searchPlaceholder={I18n.t('SEARCH_COUNTRY')}
                                                            searchNotFound={I18n.t('NO_COUNTRY_FOUND')}
                                                            specialLabel={I18n.t('WHATSAPP_NUMBER')}
                                                            placeholder={I18n.t('WHATSAPP_NUMBER')}
                                                            isValid={props.values.whatsappNumber.valid}
                                                            localization={getPhoneLang(this.props.locale)}
                                                            inputStyle={{width: '100%'}}
                                                            country={'cm'}
                                                            name="whatsappNumber"
                                                            value={props.values.whatsappNumber.formattedNumber}
                                                            onChange={(value, country) => props.setFieldValue('whatsappNumber', getFormattedPhone(value, country))}
                                                        />
                                                    </span>
                                                </div>
                                                <div className="p-inputgroup">
                                                    {getFormErrorMessage(props, 'whatsappNumber', 'formattedNumber')}
                                                </div>
                                                <div className="p-inputgroup p-mt-3">
                                                    <span className="p-float-label">
                                                        <InputText
                                                            type="text"
                                                            name="referralCode"
                                                            value={props.values.referralCode}
                                                            onChange={props.handleChange}
                                                            id="referralCode"/>
                                                        <label
                                                            htmlFor="referralCode">{I18n.t('REFERRAL_CODE_HINT')}</label>
                                                    </span>
                                                </div>

                                                <div className="p-inputgroup p-mt-3">
                                                    <span className="p-float-label">
                                                       <Password
                                                           style={{width: '100%'}}
                                                           toggleMask
                                                           name="password"
                                                           value={props.values.password}
                                                           onChange={props.handleChange}
                                                           id="password"
                                                           feedback={false}
                                                           className={classNames({'p-invalid': isFormFieldInvalid(props, 'password')})}
                                                       />
                                                        <label htmlFor="password">{I18n.t('PASSWORD')}</label>
                                                    </span>
                                                </div>
                                                <div className="p-inputgroup">
                                                    {getFormErrorMessage(props, 'password')}
                                                </div>

                                                <div className="p-inputgroup p-mt-3">
                                                    <span className="p-float-label">
                                                       <Password
                                                           style={{width: '100%'}}
                                                           toggleMask
                                                           name="password2"
                                                           value={props.values.password2}
                                                           onChange={props.handleChange}
                                                           id="password2"
                                                           feedback={false}
                                                           className={classNames({'p-invalid': isFormFieldInvalid(props, 'password2')})}
                                                       />
                                                         <label htmlFor="password2">{I18n.t('PASSWORD_REPEAT')}</label>
                                                    </span>
                                                </div>
                                                <div className="p-inputgroup">
                                                    {getFormErrorMessage(props, 'password2')}
                                                </div>

                                                <div className="p-inputgroup p-mt-3"
                                                     style={{margin: '0 auto', justifyContent: 'flex-start'}}>
                                                    <Checkbox
                                                        name="cgu"
                                                        checked={props.values.cgu}
                                                        id="cgu"
                                                        onChange={(event) => props.setFieldValue('cgu', event.checked)}
                                                    />
                                                    <label>{I18n.t('ACCEPT_TERMS_1')}&nbsp;
                                                        <Link target="_blank" className="indigo-color p-text-bold"
                                                              to="/register">{I18n.t('ACCEPT_TERMS_2')}&nbsp;</Link>
                                                        {I18n.t('ACCEPT_TERMS_3')}&nbsp;
                                                        <Link target="_blank" className="indigo-color p-text-bold"
                                                              to="/register">{I18n.t('ACCEPT_TERMS_4')}&nbsp;</Link>
                                                    </label>
                                                </div>
                                                <div className="p-inputgroup p-mb-3">
                                                    {getFormErrorMessage(props, 'cgu')}
                                                </div>

                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    width: '100%'
                                                }}>
                                                    <Button type="button" onClick={this.handlePrev}
                                                            style={{width: 'auto'}}
                                                            icon="pi pi-arrow-left"
                                                            className="login-button p-px-3"
                                                            label={I18n.t('PREVIOUS')}>
                                                    </Button>

                                                    <Button type="submit" loading={this.state.loading}
                                                            style={{width: 'auto'}}
                                                            className="login-button p-px-3"
                                                            label={I18n.t('CREATE_AN_ACCOUNT')}>
                                                    </Button>
                                                </div>
                                            </>
                                        )}
                                    </form>
                                }}
                            </Formik>
                            <div className="pages-detail p-inputgroup p-mt-2">
                                {I18n.t('ALREADY_HAVE_AN_ACCOUNT') + ' ?'} &nbsp;<NavLink
                                className="indigo-color p-text-bold" to="/login">{I18n.t('TO_LOGIN')}</NavLink>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const {isLoggedIn} = state.auth;
    const message = state.message;
    const locale = state.i18n.locale;
    return {
        isLoggedIn,
        message,
        locale
    };
}

export default connect(mapStateToProps)(Register);
